"use client";

import { App as AntdApp } from "antd";

export default function useMessage() {
  const { message } = AntdApp.useApp();

  type AddErrorParams = {
    content: string;
    debugInfo?: any;
    consoleOnly?: boolean;
  };

  const addError = ({
    content,
    debugInfo,
    consoleOnly = false
  }: AddErrorParams) => {
    if (!consoleOnly) {
      message.error(content);
    }
    console.error(content);
    if (debugInfo) {
      console.error(debugInfo);
    }
  };

  const addSuccess = (content: string) => {
    message.success(content);
  };

  return { ...message, addError, addSuccess };
}
